import { Variants } from "framer-motion";

export const wrapperAnimations: Variants = {
  initial: {
    opacity: 1,
    scale: 1.0,
    y: 0,
    transition: {
      duration: 0.35,
      easing: [0.42, 0, 0.58, 1]
    }
  },
  hover: {
    scale: 1.1
  }
};

export const playButtonAnimations: Variants = {
  initial: {
    x: "-50%",
    y: "-50%",
    scale: 1.0
  },
  hover: {
    scale: 1.1
  }
};
